var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAtlanticCanadaThumbnailContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#3A3F46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 69.5981H82.5888H91L82.5888 63.0561L70.8131 58.3832L64.9252 50.9065H58.1963L46.4206 29.4112L40.5327 32.215L28.757 21L26.2336 23.8037L22.028 29.4112L20.3458 41.5608L17.8224 46.2337H12.7757L10.2523 50.9065V58.3832L2.68224 63.0561L1 69.5981Z",
    fill: "url(#paint0_linear_4784_17720)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-iceberg",
    d: "M39.6911 55.5804V35.0197L44.7378 44.3654L55.6724 55.5804L73.3359 64.9262L49.7845 63.057L39.6911 55.5804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-iceberg",
    d: "M20.3463 59.3201L17.8229 48.1052L22.0285 41.5631L25.393 53.7126L40.5332 64.9276H27.9164L20.3463 59.3201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-iceberg",
    d: "M39.6914 35.9519L29.5979 23.8024L39.6914 55.5781V35.9519Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-iceberg",
    d: "M13.6166 49.036H17.8223L20.3456 59.3164L5.20543 64.9239L11.9344 58.3818L13.6166 49.036Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-iceberg",
    d: "M72.4958 64.928L57.3556 56.5168L60.7201 52.7784H63.2434L75.8603 63.0588L84.2715 64.928H72.4958Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-black",
    x: 44.1426,
    y: 42.0009,
    width: 2.45838,
    height: 27.8617,
    rx: 1.22919,
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-black",
    x: 53.9746,
    y: 42.0009,
    width: 2.45838,
    height: 23.7644,
    rx: 1.22919,
    transform: "rotate(90 53.9746 42.0009)",
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-black",
    x: 51.8965,
    y: 48.0901,
    width: 28.1205,
    height: 15.4663,
    fill: "#1E1E1E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-black",
    x: 51.8965,
    y: 55.1213,
    width: 35.1506,
    height: 15.4663,
    fill: "#1E1E1E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-white",
    x: 54.709,
    y: 57.9327,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-white",
    x: 54.709,
    y: 49.4967,
    width: 22.4964,
    height: 4.21807,
    rx: 0.952838,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-white",
    x: 63.1445,
    y: 57.9327,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-white",
    x: 71.5801,
    y: 57.9327,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-black",
    x: 50.2383,
    y: 45.2787,
    width: 30.9325,
    height: 2.81205,
    rx: 0.952838,
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-boat-black",
    d: "M23.7773 73.3999C32.7759 74.5248 74.3942 66.3698 96.1875 60.0427C93.3755 69.0413 89.8604 70.5879 81.4243 81.8361L27.2924 83.2421C26.1676 80.9925 24.7147 78.321 23.7773 73.3999Z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-boat-deck",
    d: "M21.3935 69.3935L21.3934 69.3935C20.8235 69.4162 20.3023 69.5232 19.8942 69.7393C19.4765 69.9604 19.1461 70.3173 19.0731 70.8191C19.0034 71.2986 19.1875 71.7933 19.5214 72.2682C19.8591 72.7484 20.3867 73.2627 21.1133 73.8077C21.287 73.9379 21.5152 74.0122 21.7307 74.0621C21.9597 74.115 22.236 74.1535 22.5495 74.1809C23.1775 74.2359 24.0001 74.2503 24.9839 74.2302C26.9541 74.19 29.6168 74.0103 32.7585 73.7187C39.0446 73.1354 47.2806 72.1014 55.7987 70.8261C64.317 69.5508 73.1244 68.0331 80.5527 66.4815C87.9608 64.9342 94.0537 63.3422 97.1028 61.9067C98.6724 61.1678 99.3965 59.648 98.9126 58.4197C98.6686 57.8002 98.134 57.3315 97.3787 57.1437C96.6363 56.9592 95.7011 57.0478 94.6024 57.4675C77.8066 63.8837 45.0442 68.4568 21.3935 69.3935Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stroke-white",
    d: "M27.9941 69.884C30.3375 72.9303 36.0085 78.7419 39.9453 77.6171C43.8822 76.4923 46.2724 71.0556 46.9755 68.4779C49.0845 71.29 50.288 76.2111 56.8176 76.2111C62.58 76.2111 64.5507 68.4779 64.5507 66.3689",
    stroke: "white",
    strokeWidth: 0.952838,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.91 1.91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stroke-black",
    d: "M34.7188 43.6398L34.7187 51.0149",
    stroke: "#1E1E1E",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-boat-black",
    d: "M30.9853 54.2928C30.5591 54.2928 30.2062 54.6413 30.286 55.06C30.3884 55.5968 30.5976 56.1104 30.9041 56.5692C31.3543 57.243 31.9942 57.7681 32.7429 58.0782C33.4916 58.3884 34.3154 58.4695 35.1102 58.3114C35.905 58.1533 36.6351 57.7631 37.2081 57.1901C37.7811 56.617 38.1714 55.887 38.3295 55.0922C38.4876 54.2974 38.4064 53.4735 38.0963 52.7249C37.7862 51.9762 37.261 51.3363 36.5872 50.886C36.1285 50.5795 35.6149 50.3703 35.078 50.268C34.6594 50.1882 34.3109 50.541 34.3109 50.9672C34.3109 51.3934 34.664 51.7277 35.0709 51.8546C35.3032 51.927 35.5253 52.0326 35.7298 52.1693C36.1498 52.4499 36.4772 52.8488 36.6705 53.3155C36.8638 53.7821 36.9143 54.2957 36.8158 54.7911C36.7172 55.2865 36.474 55.7416 36.1168 56.0988C35.7596 56.4559 35.3046 56.6992 34.8092 56.7977C34.3137 56.8963 33.8002 56.8457 33.3335 56.6524C32.8669 56.4591 32.468 56.1317 32.1873 55.7117C32.0507 55.5072 31.945 55.2852 31.8726 55.0528C31.7458 54.6459 31.4114 54.2928 30.9853 54.2928Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-boat-white",
    d: "M70.1558 78.1322C69.4516 79.7066 68.2771 81.0205 66.4215 82.0857C65.0904 82.8497 64.9956 84.6356 66.4934 84.9705C73.0593 86.4389 84.9315 86.4358 95.7974 81.519C96.1869 81.3427 96.5029 81.0251 96.6198 80.6139C96.8454 79.8198 96.9357 78.9085 96.8965 78.1553C96.7581 75.4923 95.1714 73.534 93.8309 71.3495C93.6153 70.9981 93.1194 71.171 93.1112 71.5831C93.032 75.5407 91.4815 81.4526 85.5672 81.233C85.4284 81.2278 85.2 81.3897 85.1523 81.2592C85.1096 81.1422 85.2472 81.0322 85.3176 80.9294C86.9337 78.5683 84.9063 75.1712 83.1915 73.1755C82.8631 72.7932 82.347 72.9602 82.3468 73.4641C82.3462 75.0621 82.3625 76.8928 81.36 78.2346C79.8538 80.2504 77.2552 81.6947 74.8341 82.2457C74.6931 82.2777 72.4801 82.7701 72.4366 82.6187C72.3956 82.4763 72.7176 82.0589 72.7702 81.909C73.0627 81.0759 73.0676 80.002 72.7982 79.1647C72.7062 78.8787 72.5674 78.4223 72.3979 77.9088C71.9543 76.564 70.7339 76.8396 70.1558 78.1322Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stroke-black",
    d: "M63.0808 83.6376C67.2882 82.4089 69.2855 80.5969 70.244 78.1574C70.7619 76.8394 71.9541 76.5641 72.3977 77.9088C72.5671 78.4224 72.706 78.8788 72.798 79.1647C73.0674 80.0021 73.0624 81.0759 72.77 81.909C72.7174 82.059 72.3953 82.4763 72.4363 82.6188C72.4799 82.7701 74.6929 82.2778 74.8339 82.2457C77.2549 81.6947 79.8535 80.2505 81.3597 78.2346C82.3623 76.8929 82.346 75.0622 82.3466 73.4642V73.4642C82.3468 72.9602 82.8629 72.7933 83.1913 73.1755C84.9061 75.1713 86.9335 78.5683 85.3173 80.9294C85.247 81.0322 85.1094 81.1423 85.1521 81.2593V81.2593C85.1997 81.3897 85.4282 81.2278 85.5669 81.233C91.4813 81.4526 93.0318 75.5407 93.111 71.5831C93.1192 71.171 93.615 70.9982 93.8306 71.3495V71.3495C95.1712 73.534 96.7579 75.4924 96.8963 78.1554C96.9463 79.1169 96.7853 80.3363 96.401 81.2402",
    stroke: "#1E1E1E",
    strokeWidth: 1.07134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-boat-white",
    d: "M27.4448 78.5966C26.6849 79.7132 25.6224 80.6106 24.1332 81.2792C22.733 81.9079 22.41 83.6504 23.8575 84.1605C29.6464 86.2005 40.0559 87.5174 50.1819 84.5075C50.5917 84.3857 50.9478 84.1133 51.1146 83.7196C51.3997 83.0463 51.5826 82.2641 51.6374 81.6015C51.8367 79.1923 50.6491 77.2402 49.7103 75.1148C49.5593 74.773 49.0928 74.868 49.0354 75.2372C48.4834 78.783 46.3721 83.9057 41.0855 82.9898C40.9614 82.9683 40.7365 83.0859 40.7096 82.963C40.6854 82.8527 40.8224 82.7705 40.8981 82.6867C42.6369 80.7619 41.2283 77.4638 39.9303 75.4625C39.6817 75.0792 39.1978 75.1665 39.1364 75.6192L39.1268 75.69C38.9346 77.1086 38.7164 78.7191 37.6701 79.7849C36.0721 81.4129 33.5621 82.3946 31.3201 82.5954C31.1895 82.6071 29.1416 82.7805 29.1209 82.6393C29.1014 82.5063 29.4414 82.1705 29.5069 82.0422C29.8708 81.3293 30.0057 80.3652 29.8655 79.5802C29.8282 79.3715 29.778 79.0667 29.7152 78.7146C29.4666 77.3205 28.2415 77.426 27.4448 78.5966Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stroke-black",
    d: "M20.592 82.4178C24.3463 81.8516 26.3525 80.5617 27.5334 78.6377C28.2742 77.4308 29.4662 77.3206 29.7148 78.7146C29.7776 79.0667 29.8278 79.3716 29.8651 79.5802C30.0053 80.3652 29.8704 81.3293 29.5065 82.0422C29.441 82.1705 29.1009 82.5063 29.1205 82.6393C29.1412 82.7805 31.1891 82.6071 31.3197 82.5955C33.5617 82.3946 36.0717 81.4129 37.6697 79.7849C38.7334 78.7013 38.9412 77.0547 39.1359 75.6192V75.6192C39.1974 75.1665 39.6813 75.0792 39.9299 75.4625C41.2279 77.4638 42.6365 80.762 40.8977 82.6868C40.822 82.7706 40.685 82.8527 40.7092 82.963V82.963C40.7361 83.086 40.961 82.9683 41.085 82.9898C46.3717 83.9057 48.4829 78.7831 49.0349 75.2372C49.0924 74.868 49.5589 74.773 49.7098 75.1148V75.1148C50.6487 77.2402 51.8362 79.1924 51.637 81.6015C51.5651 82.4714 51.2723 83.5473 50.8173 84.3127",
    stroke: "#1E1E1E",
    strokeWidth: 1.07134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4784_17720",
    x1: 46,
    y1: 21,
    x2: 46,
    y2: 69.5981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-stop-color",
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-stop-color",
    offset: 1,
    stopColor: "#747474",
    stopOpacity: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAtlanticCanadaThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AtlanticCanadaThumbnailContrast.ed6ff7200d9b2cf8579775a7c2ce9613.svg";